import ContributorRequestResource from "common/resources/Project/Config/Contributor/ContributorRequestResource";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import BaseProjectTeamIdApi from "./BaseProjectTeamIdApi";
import { createFormData } from "utils/FormData";

export default class ContributorApi extends BaseProjectTeamIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/contributors`;
	}

	/**
	 * @description Get all by project team id
	 */
	public async getAllByProjectTeamId(projectId: string, projectTeamId: string): Promise<ContributorResponseResource[]> {
		return this.getRequest<ContributorResponseResource[]>(this.getBaseUrl({ projectId, projectTeamId })).then((response) => ContributorResponseResource.hydrateArray(response));
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, projectTeamId: string, contributorId: string): Promise<ContributorResponseResource> {
		return this.getRequest<ContributorResponseResource>(`${this.getBaseUrl({ projectId, projectTeamId })}/${contributorId}`).then((response) =>
			ContributorResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Download contributor avatar
	 */
	public async downloadAvatar(projectId: string, projectTeamId: string, contributorId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId, projectTeamId })}/${contributorId}/avatar`);
	}

	/**
	 * @description Create a contributor for a project team
	 */
	public async create(projectId: string, projectTeamId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		const formData = createFormData(request);

		if (avatar) formData.append("file", avatar);

		return this.postRequestFormdata<ContributorResponseResource>(this.getBaseUrl({ projectId, projectTeamId }), formData).then((response) =>
			ContributorResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Update a contributor for a project team
	 */
	public async update(projectId: string, projectTeamId: string, contributorId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		const formData = createFormData(request);

		if (avatar) formData.append("file", avatar);

		return this.putRequestFormdata<ContributorResponseResource>(`${this.getBaseUrl({ projectId, projectTeamId })}/${contributorId}`, formData).then((response) =>
			ContributorResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Delete a contributor for a project team
	 */
	public async delete(projectId: string, projectTeamId: string, contributorId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, projectTeamId })}/${contributorId}`);
	}
}
